import type { DashboardScopeType } from '../types';

export const DASHBOARD_KEYS = {
  all: ['dashboard'] as const,

  byOrg: (orgId: string) => ['dashboard', orgId] as const,

  shell: (orgId: string, scopeType: DashboardScopeType, scopeId: string) =>
    ['dashboard', orgId, scopeType, scopeId, 'shell'] as const,

  widgetData: (orgId: string, scopeType: DashboardScopeType, scopeId: string, widgetId: string) =>
    ['dashboard', orgId, scopeType, scopeId, 'widget', widgetId, 'data'] as const,
};
